import { 
  SET_REPORT, 
  SET_REPORT_ANSWERS, 
  //UPDATE_REPORT_ANSWERS, 
  UPDATE_REPORT_ANSWER,
  SET_REPORT_CHECKED,
  SET_REPORT_GENERATED,
  ADD_ANSWER_IMAGE,
  REMOVE_ANSWER_IMAGE
} from '../actions/inspections';

let defaultState = {
    report: null,
    answers: [],
    reportChecked: false,
    reportGenerated: false
};

export default (state = defaultState, action) => {
  switch (action.type) {

    case SET_REPORT: {
      return Object.assign({}, state, { report: action.report });
    }

    case SET_REPORT_ANSWERS: {
      return Object.assign({}, state, { answers: action.answers });
    }

    case SET_REPORT_CHECKED: {
      if (!window.navigator.onLine) {
        action.reportChecked = true;
      }
      return Object.assign({}, state, { reportChecked: action.reportChecked });
    }

    case SET_REPORT_GENERATED: {
      return Object.assign({}, state, { reportGenerated: action.isGenerated });
    }

    case UPDATE_REPORT_ANSWER: {
      let answers = [...state.answers];
      let replaceIndex;

      // Subquestion
      if(action.answer.parent_id){
        replaceIndex = answers.findIndex(answer => answer.question_id === action.answer.parent_id);
        if(answers[replaceIndex]){
          answers[replaceIndex].subquestion = action.answer;
          answers[replaceIndex].status = action.answer.status ? action.answer.status : answers[replaceIndex].status;
        }

        return { ...state, answers};
      }
       
      replaceIndex = answers.findIndex(answer => answer.id === action.answer.id);
      if(answers[replaceIndex]){
        answers[replaceIndex] = action.answer;
      }
      
      return { ...state, answers};
    }

    case ADD_ANSWER_IMAGE: {
      let answers = [...state.answers];

      // Subquestion
      if(action.answer.parent_id){
        let answerIndex = answers.findIndex(answer => answer.question_id === action.answer.parent_id);
        if(answers[answerIndex]){
          answers[answerIndex].subquestion.images = [... state.answers[answerIndex].subquestion.images, action.image];
        }
        return { ...state, answers};
      }

      let answerIndex = answers.findIndex(answer => answer.id === action.answer.id);
      if(answers[answerIndex]){
        answers[answerIndex].images = [... state.answers[answerIndex].images, action.image];
      }
      return { ...state, answers};
    }

    case REMOVE_ANSWER_IMAGE: {
      let answers = [...state.answers];

      // Subquestion
      if(action.answer.parent_id){
        let answerIndex = answers.findIndex(answer => answer.question_id === action.answer.parent_id);
        if(answers[answerIndex]){
          let images = answers[answerIndex].subquestion.images;
          let imageIndex = images.findIndex(image => image.id === action.image.id);
          if(images[imageIndex]){
            images.splice(imageIndex, 1);
            answers[answerIndex].subquestion.images = images;
          }
        }

        return { ...state, answers};
      }

      let answerIndex = answers.findIndex(answer => answer.id === action.answer.id);
      if(answers[answerIndex]){
        let images = answers[answerIndex].images;
        let imageIndex = images.findIndex(image => image.id === action.image.id);
        if(images[imageIndex]){
          images.splice(imageIndex, 1);
          answers[answerIndex].images = images;
        }
      }
      return { ...state, answers};
    }

    case 'USER_LOGOUT': {
      return Object.assign({}, state, defaultState);
    }

    default: {
      return state;
    }
  }
};
